




































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import axios from "axios";
import BaseVue from '../../../core/BaseVue';

@Component({
  name: "forgotPassword",
  components: {}
})
export default class PasswordRecoveryComponent extends BaseVue {
  password = null;
  confirmPassword = null;
  error = false;
  loading = false;

  userID: string | null = null;
  code: string | null = null;
  get isLoggedIn() {
    return this.$store.getters.isLoggedIn;
  }

  created() {
    if (this.isLoggedIn) {
      this.$router.push("/");
    }
    this.userID = this.$route.params.userID;
    this.code = this.$route.query.code as string;
  }

  async sendMail() {
    try {
      var result = await this.$validator.validateAll();
      if (result) {
        this.loading = true;
        axios({
          url: process.env.VUE_APP_API_URL + "authentication/resetPassword",
          data: {
            userID: this.userID,
            password: this.password,
            token: this.code
          },
          method: "POST"
        })
          .then(resp => {
            this.$buefy.dialog.alert({
              title: "Cambio de contraseña",
              message: "La contraseña ha sido actualizada correctamente!",
              confirmText: "OK",
              onConfirm: value => {
                this.$router.push("/login");
              }
            });
          })
          .catch(err => {
            this.$buefy.snackbar.open({
              message:
                "Ha ocurrido un inconveniente, realiza el proceso de envio de recuperación de contraseña nuevamente.",
              type: "is-danger",
              position: "is-top",
              actionText: "Reintentar",
              onAction: () => {
                this.$router.push("/forgotPassword");
              }
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
      throw this.$validator.errors.items.map(e => e.msg);
    } catch (errors) {
      this.operationFailedErrors(errors);
    }
  }
}
